import React, { Component } from 'react'
import axios from 'axios'
import swal from 'sweetalert'
import { Button, Glyphicon } from 'react-bootstrap'
import { handleErrorFetchingData } from '../../../../functions/errorHandling'
import getServerURL from '../../../../functions/getServerURL'

class ExportAssignmentMetrics extends Component {

  state = {
    downloadingAssignmentMetrics: false,
  }


  handleExportAssignmentMetrics = () => {
    if (this.state.downloadingAssignmentMetrics) {
      return
    }

    const { sortMetricsBy, metricsFilters } = this.props

    this.setState({ downloadingAssignmentMetrics: true })

    // Only include the fields the backend needs to avoid exceeding URL length limits
    const filters = {
      search_term: metricsFilters.searchTerm,
      selected_users: (metricsFilters.selectedUsers || []).map(u => ({ first_name: u.first_name, last_name: u.last_name })),
      selected_functional_groups: (metricsFilters.selectedFunctionalGroups || []).map(g => ({ name: g.name })),
      selected_assessments: (metricsFilters.selectedAssessments || []).map(a => ({ name: a.name })),
      selected_attempt_statuses: metricsFilters.selectedAttemptStatuses,
      selected_published_statuses: metricsFilters.selectedPublishedStatuses,
    }

    axios({
      url: `${getServerURL()}export-assignment-metrics/`,
      method: 'GET',
      params: {
        filters,
        'sort_by': sortMetricsBy
      },
      headers: {
        'Authorization': "Bearer " + localStorage.getItem("token")
      },
      responseType: 'blob',
    })
    .then(response => {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      const date = new Date().toJSON().split("T")[0].split('-')
      const formattedDate = `${date[1]}-${date[2]}-${date[0]}`
      link.setAttribute('download', `QMS_Assignment_Metrics_${formattedDate}.xlsx`)
      this.setState({ downloadingAssignmentMetrics: false })
      swal({
        title: "Your file is ready",
        text: "Click the button to download",
        icon: "success",
        button: 'Download'
      })
      .then(() => {
        document.body.appendChild(link)
        link.click()
      })
    })
    .catch(error => {
      const message = "There was an error downloading your file."
      handleErrorFetchingData(error, message)
    })
  }

  render () {

    const { downloadingAssignmentMetrics } = this.state

    return (
      <Button
        disabled={downloadingAssignmentMetrics}
        onClick={this.handleExportAssignmentMetrics}
      >
        {downloadingAssignmentMetrics ?
          <Glyphicon
            glyph='refresh'
            style={{minWidth: '170px'}}
            className='rotate-btn'
          />
          :
          'Export Metrics to Excel'
        }
      </Button>
    )
  }
}

export default ExportAssignmentMetrics



// WEBPACK FOOTER //
// ./src/routes/qms-training/QMSTrainingManager/AssignmentMetricsContainer/ExportAssignmentMetrics.js